import { createClient } from "@supabase/supabase-js";

// Custom auth storage that honours the "Remember Me" preference.
//
// Key: "leasly_remember_me" in localStorage
//   "true"  → persist session across browser restarts (normal localStorage behaviour)
//   "false" → session ends when the browser is closed (sessionStorage semantics)
//   null    → not yet set (Google OAuth default) → treat as persisted
//
// How it works:
//   setItem: always writes to localStorage AND marks sessionStorage so the
//            current tab knows the session is live.
//   getItem: if remember_me is "false" AND there is no tab marker in
//            sessionStorage (i.e. this is a fresh browser session), returns
//            null so Supabase sees no persisted session and shows the login page.
//   removeItem: clears localStorage on sign-out.
const rememberMeStorage = {
  getItem(key) {
    const tabActive  = sessionStorage.getItem("leasly_session_tab");
    const rememberMe = localStorage.getItem("leasly_remember_me");
    if (!tabActive && rememberMe === "false") return null; // new session, no remember-me
    return localStorage.getItem(key);
  },
  setItem(key, value) {
    localStorage.setItem(key, value);
    sessionStorage.setItem("leasly_session_tab", "1"); // mark this tab as authenticated
  },
  removeItem(key) {
    localStorage.removeItem(key);
  },
};

export const supabase = createClient(
  "https://cweuzllrmfwbfhnuqpbc.supabase.co",
  "sb_publishable_tyCKt9npk7qJT1047wuBuw_0KSivBwP",
  {
    auth: {
      storage:        rememberMeStorage,
      persistSession: true,
    },
  }
);
